<template>
  <n-modal class="card-record" :loading="$var('load')" @close="$emit('close')">
    <h2>
      Запись в журнале
      <span v-if="edit.lab" style="float: right; font-size: .8rem"><n-button icon="trash" @click="remove" /></span>
    </h2>
    <div class="body">
      <div class="object">Проект: {{ project.title }}</div>
      <div>Дата: {{ $app.date.format(record.publishedAt) }}</div>
      <div>Статус: {{ utils.status(record.status) }}</div>
      <div>Автор: {{ record.author.fullName }}</div>

      <n-button v-if="edit.lab && !checkIfSignIsExist(user.id, 'lab')" @click="$var('acceptLab', true)">Подписать</n-button>
      <n-button v-if="edit.term && !checkIfSignIsExist(user.id, 'term')" @click="$var('acceptTer', true)">Подписать</n-button>
      <n-button v-if="edit.welder && !checkIfSignIsExist(user.id, 'welder')" @click="$var('acceptWel', true)">Подписать</n-button>
      <n-button v-if="edit.defect && !checkIfSignIsExist(user.id, 'defect')" @click="$var('acceptDef', true)">Подписать</n-button>
    </div>
    <br />
    <n-items>
      <n-input title="№ п/п" v-bind="$form.input('number')" :text="!edit.lab" />
      <n-input title="Номер линии" v-bind="$form.input('lineNum')" :text="!edit.lab" />
      <n-datepicker title="Дата предыдущей проверки, номера линии однотипных сварных стыков выполненных сварщиком после нее" v-bind="$form.input('lastCheckDate')" :text="!edit.lab" inline />
      <n-datepicker title="Дата сварки контролируемого сварного соединения" v-bind="$form.input('weldingDate')" inline :text="!edit.lab" />
      <n-input title="Номер сварного соединения по чертежам (исполнительным чертежам)" v-bind="$form.input('weldingNum')" :text="!edit.lab" />
      <n-input title="Температура, условия проведения сварки, ГРС" v-bind="$form.input('temp')" :text="!edit.lab" />
      <n-input title="Труба (ДнхS), мм, марка стали (композиция марок сталей)" v-bind="$form.input('pipe')" :text="!edit.lab" />
      <n-input title="Сварочные материалы: Электрод" v-bind="$form.input('electrod')" :text="!edit.lab" />
      <n-input title="Сварочные материалы: Проволока" v-bind="$form.input('provoloka')" :text="!edit.lab" />
      <n-input title="Сварочные материалы: флюс" v-bind="$form.input('flus')" :text="!edit.lab" />
      <n-input title="Сварочные материалы: Защитный газ" v-bind="$form.input('guardingGas')" :text="!edit.lab" />
      <n-input title="Дата термической обработки, регистрационный номер в журнале" v-bind="$form.input('termDate')" :text="!edit.lab" />
      <n-input title="Дата и номер протокола замератвердости" v-bind="$form.input('protocolNum')" :text="!edit.lab" />
      <n-input title="Результат контроля качества сварки: Радиографический или ультразвуковой контроль, номер заключения" v-bind="$form.input('result1')" :text="!edit.lab" />
      <n-input title="Результат контроля качества сварки: Механический свойства сварного соединения образца, вырезанного из контрольного стыка,номер протокола, дата" v-bind="$form.input('result2')" :text="!edit.lab" />
      <n-input title="Результат контроля качества сварки: Металография, номер протокола, дата" v-bind="$form.input('result3')" :text="!edit.lab" />
      <n-input title="Результат контроля качества сварки: ферритная фаза, номер протокола, дата" v-bind="$form.input('result4')" :text="!edit.lab" />
      <n-input title="Результат контроля качества сварки: Склонность к МКК, номер протокола, дата" v-bind="$form.input('result5')" :text="!edit.lab" />
      <n-input title="Заключение о качестве проконтролированных сварных соединений и допуске сварщика к сварке однотипных сварных соединений" v-bind="$form.input('remark')" :text="!edit.lab" />
    </n-items>
    <br />
    <n-divide>
      <n-button v-if="edit.lab" color="success" @click="save()">Сохранить</n-button>
      <n-button @click="$emit('close')">Закрыть</n-button>
    </n-divide>
    <c-modal-journal-do-sign v-if="$var('acceptLab')" @close="$var('acceptLab', false)" @submit="(s) => accept('lab', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptTer')" @close="$var('acceptTer', false)" @submit="(s) => accept('term', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptWel')" @close="$var('acceptWel', false)" @submit="(s) => accept('welder', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptDef')" @close="$var('acceptDef', false)" @submit="(s) => accept('defect', s)" />
  </n-modal>
</template>

<script>
import utils from 'utils'
import CModalJournalDoSign from 'components/journal/ModalDoSign'

export default {
  name: 'ModalRecord',
  components: { CModalJournalDoSign, },
  props: [ 'project', 'journal', ],
  data() {
    return {
      utils,
      record: { author: {}, },
      user: $app.auth.user(),
      tabs: [
        { name: 'info', title: 'Информация', callback: this.save, },
        { name: 'control', title: 'Проверяющие', },
      ],
      columns: [
        { title: 'Название', name: 'title', },
        { title: 'Расход', name: 'done', },
      ],
      translates: {
        attach: 'Приложения',
        schema: 'Исполнительные схемы',
        figure: 'Чертежи',
        input: 'Документы',
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.show
    },
    edit() {
      return {
        lab: this.record.status === 'waiting' && $app.auth.can('journals_'+this.journal.name+'_lab', this.project.id),
        term: this.record.status === 'waiting' && $app.auth.can('journals_'+this.journal.name+'_term', this.project.id),
        welder: this.record.status === 'waiting' && $app.auth.can('journals_'+this.journal.name+'_welder', this.project.id),
        defect: this.record.status === 'waiting' && $app.auth.can('journals_'+this.journal.name+'_defect', this.project.id),
      }
    },
  },
  watch: {
    '$route.query.id'() {
      this.load()
    },
  },
  created() {
    this.load()
    this.$form.init({})
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name, this.id).query({
        'with[author][with][participation]': null,
        'with[signs][with][author]': null,
        projectId: this.project.id,
      }).then((result) => {
        this.record = result.data.content
        this.$form.init(this.record)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    accept(name, sign) {
      this.$var('load', true)
      $api.journals.spec59.records.accept(this.record.id, { name, sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    save() {
      this.$var('load', true)
      $api.journals.spec59.edit(this.record.id, this.$form.get()).then(() => {
        this.load()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove() {
      this.$var('load', true)
      $api.journals.records.remove(this.journal.name, this.record.id).then(() => {
        this.load()
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    checkIfSignIsExist(userId, signName) {
      let isExist = false
      if (this.record) {
        if (this.record.signs) {
          $n.each(this.record.signs, (el) => {
            if (el.authorId !== null || el.isApproved) {
              if (el.name === signName && el.authorId === userId && el.isApproved) {
                isExist = true
              }
            }
          })
        }
      }
      return isExist
    },
  },
}
</script>

<style lang="scss" scoped>
.card-record {
  
  .weather {
    .env, .temperature, .wind {
      width: 150px;
      margin-right: 20px;
    }
  }
  

}
</style>
